import { push } from 'connected-react-router';
import * as authActions from 'stores/actions/auth';

const LOGOUT_KEY = 'wakilni_multi_tab_logout_v1';
let _store = null;
let _bc = null;

function handleRemoteLogout(payload) {
  if (!_store) return;
  const state = _store.getState();
  if (!state || !state.auth) return;

  // If already logged out, just ensure redirect
  if (!state.auth.isAuthenticated) {
    if (window.location.pathname !== '/login') {
      _store.dispatch(push('/login'));
    }
    return;
  }

  // Perform a local-only logout (do not call server) to avoid loops/races
  _store.dispatch(authActions.authLogout());
  if (window.location.pathname !== '/login') {
    _store.dispatch(push('/login'));
  }
}

export function initMultiTabAuthSync(store) {
  _store = store;

  // BroadcastChannel if available
  try {
    if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
      _bc = new BroadcastChannel('wakilni_auth_channel');
      _bc.onmessage = (ev) => {
        if (ev && ev.data && ev.data.type === 'logout') {
          handleRemoteLogout(ev.data);
        }
      };
    }
  } catch (e) {
    _bc = null;
  }

  // Storage event fallback / additional signal
  function storageHandler(e) {
    if (!e) return;
    if (e.key !== LOGOUT_KEY) return;
    try {
      const payload = JSON.parse(e.newValue);
      if (payload && payload.type === 'logout') {
        handleRemoteLogout(payload);
      }
    } catch (err) {
      // ignore
    }
  }

  window.addEventListener('storage', storageHandler, false);

  // return cleanup function if needed
  return () => {
    try {
      if (_bc) _bc.close();
    } catch (e) {}
    window.removeEventListener('storage', storageHandler, false);
    _store = null;
    _bc = null;
  };
}

// Safe broadcaster (no-op if not available yet)
export function broadcastLogout() {
  const payload = { type: 'logout', ts: Date.now() };
  try {
    if (_bc) {
      _bc.postMessage(payload);
    }
  } catch (e) {}
  try {
    localStorage.setItem(LOGOUT_KEY, JSON.stringify(payload));
  } catch (e) {}
}

export default {
  initMultiTabAuthSync,
  broadcastLogout
};
